import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { endOfDayInMilliseconds, startOfDayInMilliseconds } from '@utils/date';
import { defaultStoreDTO } from '@utils/store';

import { TRange } from '@interfaces/common/range';
import { TDefaultStoreDTO } from '@interfaces/common/store';

import { defaultMeta } from '@enums/common';

interface IInitialState extends TDefaultStoreDTO {
	organizationUser: string | null;
	updatedAt: null | TRange;
}

const initialState: IInitialState = {
	...defaultMeta,
	organizationUser: null,
	searchValue: '',
	sortDirection: false,
	sortFieldName: null,
	updatedAt: null,
};

const assetHistory = createSlice({
	name: 'assetHistory',
	initialState,
	reducers: {
		...defaultStoreDTO,
		setOrganizationUser: (state, action: PayloadAction<{ organizationUser: string | null }>) => {
			state.organizationUser = action.payload.organizationUser;
			state.page = initialState.page;
		},
		setUpdatedAt: (
			state,
			action: PayloadAction<{ updatedAt: number | null }>,
		) => {
			if (action.payload.updatedAt) {
				state.updatedAt = {
					from: startOfDayInMilliseconds(action.payload.updatedAt),
					to: endOfDayInMilliseconds(action.payload.updatedAt),
				};
			} else {
				state.updatedAt = null;
			}

			state.page = initialState.page;
		},
	},
});

export const {
	setOrganizationUser,
	setPage,
	setPageSize,
	setSort,
	setSearchValue,
	setUpdatedAt,
} = assetHistory.actions;

export default assetHistory.reducer;
